export default {
    edit: 'Edit',
    location: 'Location + T&C',
    filter: 'Filter',
};
